@if (trainingSchedule) {
  <div class="card">
    <div class="date-section">
      <div class="trainingtype">{{currentLang== 'en' ? trainingSchedule.TrainingTypeName: trainingSchedule.TrainingTypeNameFr}}</div>
      @if (!isElearning && trainingSchedule.FirstClassDate) {
        <div class="date">
          <!-- <div class="month-day">{{trainingSchedule.FirstClassDate| utcToLocalDateTime:'MMMM'}}</div> -->
          <div class="month-day">{{month}}</div>
          <!-- <div class="day">{{trainingSchedule.FirstClassDate | utcToLocalDateTime: 'dd'}} {{date}}</div> -->
          <div class="day">{{date}}</div>
          <!-- <div class="day-of-week">{{trainingSchedule.FirstClassDate | utcToLocalDateTime: 'EEEE'}}</div> -->
          <div class="day-of-week">{{day}}</div>
        </div>
      }
      @if (isElearning) {
        <div class="date">
          <div class="open">{{'TrainingSchedule.Open' | translate}}</div>
        </div>
      }
    </div>
    <div class="seats-section">
      <div class="seats">
        <label class="seats-available" for="seat-fraction">{{"Marketplace.SeatsAvailable" | translate}}</label>
        <span class="seat-fraction">
          {{isElearning ? seatsAvailable+'/'+trainingSchedule.Capacity : 'TrainingSchedule.Available' | translate}}
        </span>
        <div class="mini-hr"></div>
        <label class="course-fee">{{"Marketplace.CourseFee" | translate}}</label>
        <span class="course-fee-amount">{{trainingSchedule.Cost == null ? 'N/A' : trainingSchedule.Cost | currency}}</span>
      </div>
    </div>
    <div class="training-details">
      <div class="training-title">
        <button [class.expanded]="trainingSchedule.Expanded" (click)="expandOrCollapse()" [attr.aria-label]="trainingSchedule.Expanded? 'Show less course information': 'Show more course information'" >
          @if (!trainingSchedule.Expanded) {
            <img alt="expand" src="assets/images/chevron-down-black-grey-border.svg" />
          }
          @if (trainingSchedule.Expanded) {
            <img alt="collapse" src="assets/images/chevron-down-blue-border.svg" />
          }
        </button>
        <button class="enroll-button float-right" (click)="NavigateToEnrol()">
          <div>{{'TrainingSchedules.Enrol' | translate}}</div>
        </button>
        @if (trainingSchedule.CustomCourseName) {
          <div class="custom-course-name">
            <h2>{{trainingSchedule.CustomCourseName}}</h2>
          </div>
        }
        <h2 [style.fontWeight]="!trainingSchedule.CustomCourseName ? 'bold' : 'normal'">{{currentLang == 'en' || trainingSchedule.NameFr == '' || trainingSchedule.NameFr == null ? trainingSchedule.Name : trainingSchedule.NameFr}}</h2>
      </div>
      <div class="details-columns">
        <div class="details-cell training-type">
          <label for="type">{{'TrainingSchedule.ProvidedBy' | translate}}</label>
          <p class="type">{{trainingSchedule.TrainingProviderName}}</p>
        </div>
        <div class="details-cell training-type">
          <label for="type">{{'TrainingSchedule.ClassInformation' | translate}}</label>
          @for (class of trainingSchedule.Classes; track class) {
            <p class="date-list">{{formatUtil.capitalize(dp.transform(class.StartDate, 'MMM dd')!)}} @ {{class.StartDate | utcToLocalDateTime : 'h:mm a'}} {{'TrainingSchedule.to' | translate}} {{class.EndDate | utcToLocalDateTime : 'h:mm a'}}</p>
          }
          @if (isElearning) {
            <p class="self-paced-reqs" [innerHTML]="'TrainingSchedule.SelfpacedProgramReqs' | translate">
            </p>
          }
        </div>
        <div class="details-cell training-type">
          <label for="type">{{'TrainingSchedule.TrainingLocation' | translate}}</label>
          @if (!isElearning) {
            <p class="address">{{address | naIfEmpty}}</p>
          }
          @if (isElearning) {
            <p class="address">{{'TrainingSchedule.SelfpacedOnline' | translate}}</p>
          }
        </div>
        <div class="details-cell training-type">
          <label for="type">{{'General.Contact' | translate}}</label>
          @for (elecAddress of trainingSchedule.ElectronicAddresses; track elecAddress) {
            <p class="contact-list">
              @if (elecAddress.TypeName == 'Website') {
                {{elecAddress.TypeName[0]}}: @if (elecAddress.TypeName == 'Website') {
                <a href="javascript:void(0)" (click)="gotoTpWebsite(elecAddress.ElectronicAddressValue)">{{elecAddress.ElectronicAddressValue}}</a>
              }
            }
            @if (elecAddress.TypeName == 'Phone') {
              {{elecAddress.TypeName[0]}}: {{elecAddress.ElectronicAddressValue | phone}}
            }
            @if (elecAddress.TypeName == 'Email') {
              {{elecAddress.TypeName[0]}}: <a href="mailto:{{elecAddress.ElectronicAddressValue}}">{{elecAddress.ElectronicAddressValue}}</a>
            }
          </p>
        }
      </div>
    </div>
  </div>
</div>
}
@if (trainingSchedule.Expanded && nextCourses != null) {
  <div class="expanded-details">
    <div class="next-schedule ontario-small-6">
      <label>{{"TrainingSchedule.NextScheduleDiff" | translate}}</label>
      @if (nextCourses.NextScheduledDifferentLocation == null || nextCourses.NextScheduledDifferentLocation == undefined) {
        {{'General.NA' | translate}}
      }
      @if (!(nextCourses.NextScheduledDifferentLocation == null || nextCourses.NextScheduledDifferentLocation == undefined)) {
        <div class="details-cell training-type">
          <p class="contact-list">{{nextScheduledDifferentLocationDateCombo}}</p>
          <p class="contact-list">{{nextScheduledDifferentLocationTimeCombo}}</p>
          <p class="contact-list">{{nextScheduledDifferentLocationDayOfWeekCombo}}</p>
        </div>
        <div class="details-cell training-type">
          {{nextCourses.NextScheduledDifferentLocation.formatAddress()}}
        </div>
        <div class="details-cell training-type">
          @for (elecAddress of nextCourses.NextScheduledDifferentLocation.ElectronicAddresses; track elecAddress) {
            <p class="contact-list">
              @if (elecAddress.TypeName == 'Website') {
                <strong>{{elecAddress.TypeName[0]}}:</strong> @if (elecAddress.TypeName == 'Website') {
                <a href="javascript:void(0)" (click)="gotoTpWebsite(elecAddress.ElectronicAddressValue)">{{elecAddress.ElectronicAddressValue}}</a>
              }
            }
            @if (elecAddress.TypeName == 'Phone') {
              {{elecAddress.TypeName[0]}}: {{elecAddress.ElectronicAddressValue | phone}}
            }
            @if (elecAddress.TypeName == 'Email') {
              {{elecAddress.TypeName[0]}}: <a href="mailto:{{elecAddress.ElectronicAddressValue}}">{{elecAddress.ElectronicAddressValue}}</a>
            }
          </p>
        }
        <div class="vertical-line"></div>
      </div>
    }
  </div>
  <div class="middle-bar"></div>
  <div class="next-schedule ontario-small-6">
    <label>{{"TrainingSchedule.NextScheduleSame" | translate }}</label>
    @if (nextCourses.NextScheduledSameLocation == null || nextCourses.NextScheduledSameLocation == undefined) {
      {{'General.NA' | translate}}
    }
    @if (!(nextCourses.NextScheduledSameLocation == null || nextCourses.NextScheduledSameLocation == undefined)) {
      <div class="details-cell training-type">
        <p class="contact-list">{{nextScheduledSameLocationDateCombo}}</p>
        <p class="contact-list">{{nextScheduledSameLocationTimeCombo}}</p>
        <p class="contact-list">{{nextScheduledSameLocationDayOfWeekCombo}}</p>
      </div>
      <div class="details-cell training-type same-location-address">
        {{nextCourses.NextScheduledSameLocation.formatAddress()}}
      </div>
      <div class="details-cell training-type">
        @for (elecAddress of nextCourses.NextScheduledSameLocation.ElectronicAddresses; track elecAddress) {
          <p class="contact-list">
            @if (elecAddress.TypeName == 'Website') {
              <strong>{{elecAddress.TypeName[0]}}:</strong> @if (elecAddress.TypeName == 'Website') {
              <a href="javascript:void(0)" (click)="gotoTpWebsite(elecAddress.ElectronicAddressValue)">{{elecAddress.ElectronicAddressValue}}</a>
            }
          }
          @if (elecAddress.TypeName == 'Phone') {
            {{elecAddress.TypeName[0]}}: {{elecAddress.ElectronicAddressValue | phone}}
          }
          @if (elecAddress.TypeName == 'Email') {
            {{elecAddress.TypeName[0]}}: <a href="mailto:{{elecAddress.ElectronicAddressValue}}">{{elecAddress.ElectronicAddressValue}}</a>
          }
        </p>
      }
    </div>
  }
</div>
</div>
}
